import React from 'react'
import styled from 'styled-components'

import { fontSizeResponsive, mediaQ } from '../../theme/mixins'

const NewsItemContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: end;
  align-self: flex-start;
  justify-content: center;
  margin-right: 3.7vw;
  cursor: pointer;

  @media (max-width: 1370px) {
    margin-right: 6%;
  }
  ${mediaQ('mobileAll', 'margin-right: 10px;')}
  max-width: 150px;
`
const NewsItemImage = styled.div`
  width: 150px;
  height: 150px;
  /* temporary settings below  */
  background: url(${(props) => props.source});
  background-position: 50% 20%;
  background-size: cover;
`
const NewsHeader = styled.div`
  font-family: 'Asap Condensed';
  ${fontSizeResponsive(23)};

  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  letter-spacing: normal;
  color: #fe0d9f;
  text-align: left;
  width: 100%;
  padding: 5px 0 5px 0;
`
const NewsDescription = styled.div`
  font-family: 'Open Sans', sans-serif;
  width: 100%;
  ${fontSizeResponsive(20)};
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #212121;
  margin: 2px 0 10% 0;
`

const NewsItem = ({
  image,
  header,
  description,
  currentNews,
  openVideo,
  i,
}) => (
  <NewsItemContainer
    onClick={() => openVideo(currentNews.uri, currentNews.name, i + 1)}
  >
    <NewsItemImage source={image} />
    <NewsHeader> {header} </NewsHeader>
    <NewsDescription>{description}</NewsDescription>
  </NewsItemContainer>
)

export default NewsItem
